export default "__VITE_ASSET__DUShBU2P__"